import { useEffect, useState } from 'react'; // import React, { useState }
import { resetPassword, type ResetPasswordOutput } from 'aws-amplify/auth';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
// import { useNavigate } from 'react-router-dom';
import CustomModal from '../../../components/Modals/CustomModal';
import { Button, Container, Form, InputGroup, Modal } from 'react-bootstrap';

const normalizeLocale = (locale: string): string => {
  const match = locale.match(/^[a-zA-Z]+/);
  return match ? match[0] : "en"; //locale;
};

const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Email as username
type ForgotPasswordData = {
  username: string;
};

const ForgotPasswordScreen = () => {
  const { t } = useTranslation();
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const {register, control, handleSubmit, watch, reset} = useForm<ForgotPasswordData>();
  // const navigate = useNavigate();

  useEffect(() => {
    document.title = t('title.forgotPassword');
  }, []);

  const onSendPressed = async ({username}: ForgotPasswordData) => {
    if (loading) {
      return;
    };
    if (!validateEmail(username)) {
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>{t("signup.error")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t("signup.badEmail")}</p>
        </Modal.Body></>);
      setShowCustomModal(true);
      return;
    }
    setLoading(true);
    try {
      const output = await resetPassword({username});
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>{t("signup.resetPasswordTitleAlert")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{`${t("signup.resetPasswordAlertMessage")}${output.nextStep.codeDeliveryDetails.destination}`}</p>
        </Modal.Body></>);
      setLinkModal('/newPassword');
      setShowCustomModal(true);
      handleResetPasswordNextSteps(output);
    } catch (error) {
      console.log('error to resend code: ', error);
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>Sorry</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{(error as Error).message}</p>
        </Modal.Body></>);
      setShowCustomModal(true);
    };
    setLoading(false);
    reset();
  };

  function handleResetPasswordNextSteps(output: ResetPasswordOutput) {
    const { nextStep } = output;
    // console.log('nextStep: ', nextStep);
    switch (nextStep.resetPasswordStep) {
      case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
        const codeDeliveryDetails = nextStep.codeDeliveryDetails;
        // console.log(
        //   `Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`
        // );
        // Collect the confirmation code from the user and pass to confirmResetPassword.
        break;
      case 'DONE':
        // console.log('Successfully reset password.');
        break;
    }
  }

  // const onSignInPress = () => {
  //   navigate('/cognito/signIn');
  // };

  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        // animation={true}
      />
      <Form className="register-form">
        <h2 className="text-center">{t('signup.forget_password')}</h2>
        <Container className="">
              <InputGroup>
                <Form.Control
                  name="username"
                  placeholder={t("signup.email")}
                  aria-describedby="basic-addon1"
                  className="d-inline me-lg-2"
                  {...register("username")}
                  aria-label="Username"
                />
              </InputGroup>

              
              <InputGroup>
                <Button type="submit" onClick={handleSubmit(onSendPressed)}>{loading ? t('signup.loading') : t("signup.send")}</Button>
              </InputGroup>
          </Container>
        </Form>
      </>
  );
};

export default ForgotPasswordScreen;
